import React, {Component, Fragment} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {_gatherEntitlements, _openModal, _runsAsInvestorSession, _setSession, _setSsoToken} from '../store';
import history from '../../history';
import debug from 'debug';
import styled from 'styled-components/macro';
import Image from './Image';
import Row from './Row';
import axiosInstance from '../utils/axios';
import {formatter} from '../utils/utils';
import qs from 'query-string';

const log = debug('circleblack:splash-page');

const _Splash = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: ${props => props.theme.backgroundColor};
  border-radius: 10px;
  top: 0;
  left: 0;
  z-index: 99999999;

  ${props => !props.timedLoading && `
    opacity:0;
    width:0;
    height:0;
    transition: width 0.5s 0.5s, height 0.5s 0.5s, opacity 0.3s;
    `};
`;

class SplashPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      timedLoading: true, // Uncomment for timed splash
    };
    log('constructing');
    const {session, gatherEntitlements, setSession, runsAsInvestorSession, setSsoToken, openModal} = this.props;
    const locationSearch = qs.parse(window.location.search);
    const ssoToken = locationSearch.ssoToken || locationSearch.sso;
    if (localStorage.runAsInvestor) {
      localStorage.removeItem('token');
      localStorage.removeItem('email');
      localStorage.removeItem('entitlements');
      localStorage.removeItem('runAsInvestor');
      localStorage.removeItem('initialLoad');
    }
    if (ssoToken) {
      setSsoToken(ssoToken);
      this.state.loading = true;
      axiosInstance.post('auth/sso', {ssoToken, skipDelete: 1})
        .then(res => {
          if (!res.data) {
            openModal({
              type: 'MessageModal',
              title: 'Single Sign-On Unsuccessful',
              body: `The single sign-on linkage could not be created. Please try relaunching the platform and entering credentials again. If the problem persists please contact ${this.props.product?.brand?.advisorCSEmail} or ${formatter(
                'phone'
              )(this.props.product?.brand?.advisorCSPhone)} for assistance.`,
            });
            history.push('/login');
          } else {
            if (res.data.user && res.data.session && res.data.agent) {
              return runsAsInvestorSession(res.data);
            }
            if (res.data.email && res.data.token && res.data.partner) {
              return setSession({email: res.data.email, token: res.data.token, partner: res.data.partner});
            }
            if (res.data.isLinked) {
              history.push('/sso/users');
            } else {
              history.push('/login');
            }
          }
        })
        .catch(err => {
          openModal({type: 'Error', title: 'Single Sign-On Unsuccessful', err});
          history.push('/login');
        })
        .finally(() => {this.state.loading = false;});
    } else if (session.token || localStorage.token) {
      log('gatherEntitlements');
      this.state.loading = true;
      gatherEntitlements()
        .then(() => this.setState({loading: false}));
    } else {
      log('pushing /login to history');
      history.push('/login');
    }
  }

  componentDidMount() {
    log('mounted');
    setTimeout(() => this.setState({timedLoading: false}), 2000);
  }

  render() {
    log('rendering');
    return <Fragment>{!this.state.loading && this.props.children}
      <_Splash timedLoading={this.state.timedLoading || this.state.loading}>
        <Row height={'100%'} width={'100%'} alignSubRow={'middle'} alignItems={'middle'}>
          {(!!this.state.timedLoading || !!this.state.loading) && <Image src={this.props.product?.brand?.logo}
                                                                         maxWidth={'250px'}
                                                                         maxHeight={'250px'}/>}
        </Row>
      </_Splash>
    </Fragment>;
  }
}

const mapStateToProps = state => ({
  session: state.session,
  product: state.product,
});

const mapDispatchToProps = dispatch => ({
  gatherEntitlements: () => dispatch(_gatherEntitlements(false, true)),
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
  setSession: credentials => dispatch(_setSession(credentials)),
  setSsoToken: ssoToken => dispatch(_setSsoToken(ssoToken)),
  runsAsInvestorSession: data => dispatch(_runsAsInvestorSession(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SplashPage));

SplashPage.propTypes = {
  session: PropTypes.shape({
    token: PropTypes.string.isRequired,
    entitlements: PropTypes.isRequired,
    profile: PropTypes.object.isRequired,
    entryPage: PropTypes.shape({
      path: PropTypes.string,
      redirect: PropTypes.bool,
    }).isRequired,
  }).isRequired,
  product: PropTypes.object,
  gatherEntitlements: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  setSession: PropTypes.func.isRequired,
  setSsoToken: PropTypes.func.isRequired,
  runsAsInvestorSession: PropTypes.func.isRequired,
  children: PropTypes.node,
};
